export const STARTING_TIME = {
    minute: 59,
    second: 59
}

export const STARTING_LEVEL = 1;

export const TOTAL_LEVEL = 10;

export const INITIAL_LIVES = 5;

// in seconds
export const TIME_BONUS_PER_LEVEL = 0;

export const LIVES_BONUS_PER_LEVEL = 0;

export const NEW_DATA_EVENT = "NEW_DATA_EVENT";